import React, { useEffect } from 'react';
import { BsCheckCircleFill, BsXCircleFill, BsExclamationTriangleFill } from 'react-icons/bs';

// Custom Notification Component
const Notification = ({ message, type, onClose, duration = 4000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const getNotificationStyles = () => {
    const baseStyles = {
      position: 'fixed',
      top: '20px',
      right: '20px',
      minWidth: '300px',
      maxWidth: '500px',
      padding: '16px 20px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
      zIndex: 9999,
      animation: 'slideInRight 0.3s ease-out',
      fontWeight: '500',
      fontSize: '14px'
    };

    switch (type) {
      case 'success':
        return {
          ...baseStyles,
          backgroundColor: '#10b981',
          color: 'white',
          border: '1px solid #059669'
        };
      case 'error':
        return {
          ...baseStyles,
          backgroundColor: '#ef4444',
          color: 'white',
          border: '1px solid #dc2626'
        };
      case 'warning':
        return {
          ...baseStyles,
          backgroundColor: '#f59e0b',
          color: 'white',
          border: '1px solid #d97706'
        };
      default:
        return {
          ...baseStyles,
          backgroundColor: '#3b82f6',
          color: 'white',
          border: '1px solid #2563eb'
        };
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <BsCheckCircleFill size={20} />;
      case 'error':
        return <BsXCircleFill size={20} />;
      case 'warning':
        return <BsExclamationTriangleFill size={20} />;
      default:
        return <BsCheckCircleFill size={20} />;
    }
  };

  return (
    <div style={getNotificationStyles()}>
      {getIcon()}
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={onClose}
        style={{
          background: 'transparent',
          border: 'none',
          color: 'inherit',
          cursor: 'pointer',
          fontSize: '18px',
          lineHeight: 1,
          opacity: 0.7,
          transition: 'opacity 0.2s ease'
        }}
        onMouseOver={(e) => e.target.style.opacity = '1'}
        onMouseOut={(e) => e.target.style.opacity = '0.7'}
      >
        ×
      </button>
    </div>
  );
};

export default Notification;
